import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/redirect';

// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: true };

/** 取得舊版線上交易專區登入所需要資訊 */
export function getRedirectGD(token) {
    return get(`${url}/gd?token=${token}`, { ...options, repeatRequestCancel: true });
};

export function postRedirectAccount(data) {
    return post(`${url}/redirectAccount`, data, {
        ...options,
        repeatRequestCancel: true,
    });
};
